(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultDeleteController',PhoneCallResultDeleteController);

    PhoneCallResultDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneCallResult'];

    function PhoneCallResultDeleteController($uibModalInstance, entity, PhoneCallResult) {
        var vm = this;

        vm.phoneCallResult = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneCallResult.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
